export { default as PaymentMethodsInfo } from "./PaymentMethodsInfo";
